/*!
 * Rolacase Chat Widget
 * Loaded by snippets/chat-widget.liquid via {{ 'chat-widget.js' | asset_url | script_tag }}
 * Configuration injected at render time via window.RC_CHAT_CONFIG.
 */
(function() {
  'use strict';

  var CFG = window.RC_CHAT_CONFIG || {};
  var STORE = CFG.store === 'AU' ? 'AU' : 'US';
  var API_BASE = CFG.apiBase || 'https://api.rolacase.us';
  var WS_BASE = API_BASE.replace('https://', 'wss://').replace('http://', 'ws://');
  var API_KEY = CFG.apiKey || 'rola-dp-7f3k9x2m4p';
  var CALL_TEL = STORE === 'AU' ? '+61243401444' : '+18573340300';
  var PHONE_FALLBACK = STORE === 'AU' ? '02 4340 1444' : '857-334-0300';

  var STORAGE_KEY = 'rc_chat_session';
  var SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var SILENCE_THRESHOLD_MS = 30 * 1000;
  var GREETING_KEY = 'rc_greeting_auto';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function timeNow() {
    return new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }

  function makeSvg(attrs, childSpecs) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    Object.keys(attrs).forEach(function(k) { svg.setAttribute(k, attrs[k]); });
    childSpecs.forEach(function(spec) {
      var el = document.createElementNS(SVG_NS, spec.tag);
      Object.keys(spec.attrs).forEach(function(k) { el.setAttribute(k, spec.attrs[k]); });
      svg.appendChild(el);
    });
    return svg;
  }

  function buildBubbleIcon() {
    return makeSvg(
      { class: 'rc-bubble__icon', width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', stroke: '#fff', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' },
      [
        { tag: 'rect', attrs: { x: '5', y: '2', width: '14', height: '20', rx: '2', ry: '2' } },
        { tag: 'line', attrs: { x1: '12', y1: '18', x2: '12.01', y2: '18' } }
      ]
    );
  }

  function buildCloseIcon() {
    return makeSvg(
      { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', stroke: '#fff', 'stroke-width': '2.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' },
      [
        { tag: 'line', attrs: { x1: '18', y1: '6', x2: '6', y2: '18' } },
        { tag: 'line', attrs: { x1: '6', y1: '6', x2: '18', y2: '18' } }
      ]
    );
  }

  function setCallBtnVisible(show) {
    var btn = document.getElementById('rc-call-btn');
    if (btn) btn.style.display = show ? 'flex' : 'none';
  }

  function onCallBtnClick() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'call_button_click',
        store: STORE,
        chat_session_id: sessionId || null,
        phone: CALL_TEL
      });
    } catch (err) {}

    if (sessionId) {
      try {
        fetch(API_BASE + '/api/v1/admin/chat/sessions/' + sessionId + '/call-click', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
          body: JSON.stringify({ store: STORE, phone: CALL_TEL }),
          keepalive: true
        }).catch(function() {});
      } catch (err) {}
    }
  }

  var bubble = document.getElementById('rc-chat-bubble');
  var panel = document.getElementById('rc-chat-panel');
  var overlay = document.getElementById('rc-chat-overlay');
  var messagesEl = document.getElementById('rc-messages');
  var form = document.getElementById('rc-chat-form');
  var fieldsEl = document.getElementById('rc-fields');
  var nameInput = document.getElementById('rc-name');
  var phoneInput = document.getElementById('rc-phone');
  var msgInput = document.getElementById('rc-message');
  var fileInput = document.getElementById('rc-file');
  var filePreview = document.getElementById('rc-file-preview');
  var fileName = document.getElementById('rc-file-name');
  var fileRemove = document.getElementById('rc-file-remove');
  var unreadBadge = document.getElementById('rc-unread-badge');
  var statusDot = document.getElementById('rc-status-dot');
  var statusText = document.getElementById('rc-status-text');

  function setStatus(state) {
    if (!statusDot || !statusText) return;
    if (state === 'online' || state === 'connected') {
      statusDot.style.background = '#4ade80';
      statusText.textContent = state === 'online' ? 'Online' : 'Connected';
    } else if (state === 'reconnecting') {
      statusDot.style.background = '#f59e0b';
      statusText.textContent = 'Reconnecting...';
    } else {
      statusDot.style.background = '#94a3b8';
      statusText.textContent = 'Offline';
    }
  }

  var isOpen = false;
  var socket = null;
  var sessionId = null;
  var unreadCount = 0;
  var pendingFile = null;
  var typingTimeout = null;
  var reconnectTimer = null;
  var reconnectDelay = 1000;
  var hasSession = false;
  var optimisticFirstMessageBody = null;
  var silenceTimer = null;
  var silenceBubbleShown = false;

  function loadSession() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!raw || !raw.sessionId) return {};
      if (raw.savedAt && (Date.now() - raw.savedAt > SESSION_TTL_MS)) {
        localStorage.removeItem(STORAGE_KEY);
        return {};
      }
      return raw;
    } catch (e) {
      return {};
    }
  }

  function saveSession(data) {
    try {
      var payload = Object.assign({}, data, { savedAt: Date.now() });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function addMsg(text, dir, meta, delay) {
    return new Promise(function(resolve) {
      setTimeout(function() {
        var wrap = document.createElement('div');
        wrap.className = 'rc-msg rc-msg--' + dir;
        var bub = document.createElement('div');
        bub.className = 'rc-msg__bubble';
        bub.textContent = text;
        wrap.appendChild(bub);
        if (meta) {
          var m = document.createElement('span');
          m.className = 'rc-msg__meta';
          m.textContent = meta;
          wrap.appendChild(m);
        }
        messagesEl.appendChild(wrap);
        messagesEl.scrollTop = messagesEl.scrollHeight;
        resolve(wrap);
      }, delay || 0);
    });
  }

  function addMsgWithAttachment(text, attachment, dir, meta) {
    var wrap = document.createElement('div');
    wrap.className = 'rc-msg rc-msg--' + dir;
    if (text) {
      var bub = document.createElement('div');
      bub.className = 'rc-msg__bubble';
      bub.textContent = text;
      wrap.appendChild(bub);
    }
    if (attachment) {
      if (attachment.content_type && attachment.content_type.indexOf('image/') === 0) {
        var img = document.createElement('img');
        img.className = 'rc-msg__img';
        img.src = attachment.data || attachment.url;
        img.alt = attachment.filename;
        img.addEventListener('click', function() { window.open(img.src, '_blank'); });
        wrap.appendChild(img);
      } else {
        var link = document.createElement('a');
        link.className = 'rc-msg__file';
        link.href = attachment.data || attachment.url;
        link.target = '_blank';
        link.textContent = attachment.filename;
        wrap.appendChild(link);
      }
    }
    if (meta) {
      var m = document.createElement('span');
      m.className = 'rc-msg__meta';
      m.textContent = meta;
      wrap.appendChild(m);
    }
    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  var typingEl = null;
  function showTyping() {
    if (typingEl) return;
    typingEl = document.createElement('div');
    typingEl.className = 'rc-msg rc-msg--in rc-typing';
    var bub = document.createElement('div');
    bub.className = 'rc-msg__bubble';
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'rc-typing__dot';
      bub.appendChild(dot);
    }
    typingEl.appendChild(bub);
    messagesEl.appendChild(typingEl);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideTyping() {
    if (typingEl && typingEl.parentNode) typingEl.parentNode.removeChild(typingEl);
    typingEl = null;
  }

  function incrementUnread() {
    if (isOpen) return;
    unreadCount++;
    unreadBadge.textContent = unreadCount;
    unreadBadge.style.display = 'flex';
  }

  function clearUnread() {
    unreadCount = 0;
    unreadBadge.style.display = 'none';
  }

  function startSilenceTimer() {
    cancelSilenceTimer();
    if (silenceBubbleShown) return;
    silenceTimer = setTimeout(function() {
      if (silenceBubbleShown) return;
      silenceBubbleShown = true;
      addMsg("Thanks for your patience. Our team will reply as soon as we're online.", 'in', null, 0);
    }, SILENCE_THRESHOLD_MS);
  }

  function cancelSilenceTimer() {
    if (silenceTimer) {
      clearTimeout(silenceTimer);
      silenceTimer = null;
    }
  }

  function resetSilenceState() {
    cancelSilenceTimer();
    silenceBubbleShown = false;
  }

  fileInput.addEventListener('change', function() {
    if (fileInput.files.length > 0) {
      pendingFile = fileInput.files[0];
      if (pendingFile.size > 2 * 1024 * 1024) {
        pendingFile = null;
        fileInput.value = '';
        addMsg('File too large. Maximum 2 MB.', 'in', null, 0);
        return;
      }
      fileName.textContent = pendingFile.name;
      filePreview.style.display = 'flex';
    }
  });

  fileRemove.addEventListener('click', function() {
    pendingFile = null;
    fileInput.value = '';
    filePreview.style.display = 'none';
  });

  function fileToBase64(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function connectWS() {
    if (!sessionId) return;
    if (socket && socket.readyState <= 1) return;

    socket = new WebSocket(WS_BASE + '/ws/chat/' + sessionId);

    socket.onopen = function() {
      reconnectDelay = 1000;
      setStatus('connected');
    };

    socket.onmessage = function(event) {
      var env = JSON.parse(event.data);

      if (env.type === 'message' && env.from === 'admin') {
        hideTyping();
        resetSilenceState();
        var msg = env.message || {};
        if (msg.attachment_url) {
          addMsgWithAttachment(msg.body, { data: msg.attachment_url, filename: msg.attachment_name, content_type: msg.attachment_type }, 'in', timeNow());
        } else {
          addMsg(msg.body || env.body, 'in', timeNow(), 0);
        }
        incrementUnread();
        playSound();
      }

      if (env.type === 'typing' && env.from === 'admin') {
        showTyping();
        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(hideTyping, 3000);
      }

      if (env.type === 'session_update' && env.body === 'closed') {
        addMsg('This conversation has been closed. Thank you for chatting with us.', 'in', null, 0);
        msgInput.disabled = true;
        if (sendBtnForm) sendBtnForm.disabled = true;
        msgInput.placeholder = 'Session ended';
        setStatus('offline');
        if (socket) socket.close();
        localStorage.removeItem(STORAGE_KEY);
      }
    };

    socket.onclose = function() {
      setStatus('reconnecting');
      clearTimeout(reconnectTimer);
      reconnectTimer = setTimeout(function() {
        reconnectDelay = Math.min(reconnectDelay * 2, 15000);
        connectWS();
      }, reconnectDelay);
    };

    socket.onerror = function() { socket.close(); };
  }

  function sendWS(type, body, attachment) {
    if (!socket || socket.readyState !== 1) return false;
    var payload = { type: type, session_id: sessionId, body: body || '' };
    if (attachment) payload.attachment = attachment;
    // socket.send can throw (INVALID_STATE_ERR) on a socket that is closing or
    // has just gone half-open even though readyState still reads 1; on a throw,
    // return false so deliverFollowUp uses the REST fallback instead of leaving
    // a phantom 'Sent'. (The remaining half-open case where send SUCCEEDS but
    // the bytes never leave needs a server-side ACK protocol — tracked, not a
    // rushed change here.)
    try { socket.send(JSON.stringify(payload)); } catch (e) { return false; }
    return true;
  }

  // deliverFollowUp sends a follow-up message and guarantees it is never
  // silently lost. It tries the live WebSocket first; when the socket is not
  // open (handshake race, reconnect backoff, or a reused/closed session) it
  // falls back to the REST endpoint so the message is persisted + the team is
  // notified. Only if BOTH fail does it surface a visible "not delivered"
  // notice instead of leaving a phantom "Sent" bubble (audit bug #3, 2026-07-01).
  function deliverFollowUp(message, attachment) {
    if (sendWS('message', message, attachment || undefined)) return;
    if (!sessionId) { resetToFreshSession(); return; }
    var body = { message: message };
    if (attachment) body.attachment = attachment;
    fetch(API_BASE + '/api/v1/chat/sessions/' + sessionId + '/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
      body: JSON.stringify(body)
    }).then(function(res) {
      // 410 (closed) / 404 (stale or missing id): the session is gone server
      // side. Drop the stale id AND return to the start form so the NEXT
      // submit opens a fresh session — without also resetting hasSession the
      // next message would route back here with a null id and silently drop.
      if (res.status === 410 || res.status === 404) {
        resetToFreshSession();
        return;
      }
      if (!res.ok) throw new Error('rest-fallback-failed');
    }).catch(function() {
      addMsg('Your message did not go through. Please check your connection and send it again.', 'in', '', 0);
    });
  }

  // resetToFreshSession clears a dead session and restores the name/phone form
  // view so the next submit routes to handleFirstMessage (a clean new session)
  // instead of the follow-up path against a null id.
  function resetToFreshSession() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    sessionId = null;
    hasSession = false;
    var fv = document.getElementById('rc-form-view');
    var cv = document.getElementById('rc-chat-view');
    if (fv) fv.style.display = 'block';
    if (cv) cv.style.display = 'none';
    addMsg('This chat has ended. Send a new message to start again.', 'in', '', 0);
  }

  var audioCtx = null;
  function playSound() {
    try {
      if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      var osc = audioCtx.createOscillator();
      var gain = audioCtx.createGain();
      osc.connect(gain); gain.connect(audioCtx.destination);
      osc.frequency.value = 880; osc.type = 'sine';
      gain.gain.setValueAtTime(0.1, audioCtx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.3);
      osc.start(); osc.stop(audioCtx.currentTime + 0.3);
    } catch (e) {}
  }

  function openPanel() {
    panel.style.display = 'flex';
    overlay.style.display = 'block';
    morphToClose();
    requestAnimationFrame(function() {
      panel.classList.add('rc-open');
      overlay.classList.add('rc-open');
    });
    bubble.setAttribute('aria-expanded', 'true');
    isOpen = true;
    clearUnread();
    setStatus(hasSession ? 'connected' : 'online');
    try {
      if (window.RolacaseTrack && typeof window.RolacaseTrack.track === 'function') {
        window.RolacaseTrack.track('chat_open');
      }
    } catch (_) {}

    var saved = loadSession();
    if (saved.sessionId && saved.name) {
      sessionId = saved.sessionId;
      hasSession = true;

      var formView = document.getElementById('rc-form-view');
      var chatView = document.getElementById('rc-chat-view');
      if (formView) formView.style.display = 'none';
      if (chatView) chatView.style.display = 'flex';
      setCallBtnVisible(true);

      if (messagesEl && messagesEl.children.length === 0) {
        addMsg('Welcome back, ' + saved.name + '.', 'in', null, 200);
        loadHistory();
      }
      connectWS();
      var chatMsgInput = document.getElementById('rc-message-chat');
      if (chatMsgInput) setTimeout(function() { chatMsgInput.focus(); }, 300);
    } else {
      var formViewElse = document.getElementById('rc-form-view');
      var chatViewElse = document.getElementById('rc-chat-view');
      if (formViewElse) formViewElse.style.display = 'block';
      if (chatViewElse) chatViewElse.style.display = 'none';
      setCallBtnVisible(false);

      fieldsEl.classList.remove('rc-hidden');
      if (sendBtnForm) sendBtnForm.disabled = true;
      msgInput.value = '';
      msgInput.disabled = false;

      if (saved.name) nameInput.value = saved.name;
      if (saved.phone) phoneInput.value = saved.phone;

      updateValidation();

      setTimeout(function() {
        if (saved.name && saved.phone) msgInput.focus();
        else nameInput.focus();
      }, 800);
    }
  }

  function closePanel() {
    panel.classList.remove('rc-open');
    overlay.classList.remove('rc-open');
    bubble.setAttribute('aria-expanded', 'false');
    morphToBubble();
    isOpen = false;
    setTimeout(function() {
      panel.style.display = 'none';
      overlay.style.display = 'none';
    }, 250);
  }

  function loadHistory() {
    fetch(API_BASE + '/api/v1/admin/chat/sessions/' + sessionId, {
      headers: { 'X-API-Key': API_KEY }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var msgs = (data.session && data.session.messages) || data.messages || [];
      var skippedOptimistic = false;
      msgs.forEach(function(m) {
        var dir = m.direction === 'inbound' ? 'out' : 'in';
        var meta = m.created_at ? new Date(m.created_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '';
        if (!skippedOptimistic && optimisticFirstMessageBody && dir === 'out' && m.body === optimisticFirstMessageBody) {
          skippedOptimistic = true;
          return;
        }
        if (m.attachment_url) {
          addMsgWithAttachment(m.body, { data: m.attachment_url, filename: m.attachment_name, content_type: m.attachment_type }, dir, meta);
        } else if (m.body) {
          addMsg(m.body, dir, meta, 0);
        }
      });
    })
    .catch(function() {});
  }

  function validate(firstTime) {
    var ok = true;
    [nameInput, phoneInput, msgInput].forEach(function(el) { el.classList.remove('rc-error'); });
    if (firstTime) {
      if (!nameInput.value.trim()) { nameInput.classList.add('rc-error'); ok = false; }
      var digits = phoneInput.value.replace(/\D/g, '');
      if (digits.length < 8 || digits.length > 15) { phoneInput.classList.add('rc-error'); ok = false; }
    }
    if (!msgInput.value.trim() && !pendingFile) { msgInput.classList.add('rc-error'); ok = false; }
    return ok;
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!hasSession) {
      handleFirstMessage();
    } else {
      handleFollowUpMessage();
    }
  });

  // Recover a chat first-message lead the API POST could not deliver (2026-07-29
  // lead-loss fix, sibling of the -44% form bug). Called ONLY on a transport
  // failure — the cross-origin POST to api.rolacase was blocked (ad-blocker/
  // proxy/DNS) and NEVER reached the server, so this native Shopify /contact
  // POST cannot duplicate it. /contact is same-origin (the store domain), which
  // ad-blockers do not block, and routes to the store's own contact inbox (AU
  // enquiry@ / the US store's email). Carries the full chat lead in
  // contact[body]. Navigates to the /contact success page — acceptable, the
  // lead is captured instead of lost. One-shot guard prevents any double POST.
  function chatNativeFallback(payload) {
    try {
      if (window.__rcChatFallbackDone) return false;
      window.__rcChatFallbackDone = true;
      var lines = [
        'WEB CHAT MESSAGE (recovered via fallback — the chat server was unreachable from this browser)',
        'Name: ' + (payload.name || ''),
        'Phone: ' + (payload.phone || ''),
        'Message: ' + (payload.message || ''),
        'Landing page: ' + (payload.landing_page || ''),
        'Referrer: ' + (payload.referrer || '')
      ];
      if (payload.utm_source) lines.push('UTM: ' + payload.utm_source + ' / ' + (payload.utm_medium || '') + ' / ' + (payload.utm_campaign || ''));
      var f = document.createElement('form');
      f.method = 'post'; f.action = '/contact'; f.style.display = 'none';
      function add(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = (v == null ? '' : String(v)); f.appendChild(i); }
      add('form_type', 'contact');
      add('utf8', '✓');
      add('contact[Name]', payload.name || '');
      add('contact[email]', payload.email || '');
      add('contact[phone]', payload.phone || '');
      add('contact[body]', lines.join('\n'));
      document.body.appendChild(f);
      // Prototype method (not f.submit()) for parity with the sibling fallbacks
      // (contact-form-capture / dealer form / hcaptcha guard): a hidden field
      // named "submit" would shadow the method and throw. The submit METHOD
      // fires no submit event, so no capture-listener re-entry / double POST.
      HTMLFormElement.prototype.submit.call(f);
      return true;
    } catch (e) { return false; }
  }

  function handleFirstMessage() {
    if (!validate(true)) return;

    var name = nameInput.value.trim();
    var phone = phoneInput.value.trim();
    var email = '';
    var message = msgInput.value.trim();

    fieldsEl.classList.add('rc-hidden');
    if (sendBtnForm) { sendBtnForm.disabled = true; sendBtnForm.textContent = 'Sending...'; }
    var welcomeBubble = document.querySelector('.rc-welcome-bubble');
    if (welcomeBubble) welcomeBubble.textContent = 'Sending your message...';

    var payload = { name: name, phone: phone, message: message, store: STORE };
    if (email) payload.email = email;

    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('utm_source'))   payload.utm_source   = params.get('utm_source');
      if (params.get('utm_medium'))   payload.utm_medium   = params.get('utm_medium');
      if (params.get('utm_campaign')) payload.utm_campaign = params.get('utm_campaign');
      if (document.referrer)          payload.referrer     = document.referrer;
      payload.landing_page = window.location.href;
    } catch (e) {}

    try {
      var hp = document.querySelector('input[name="rc-website"]');
      if (hp && hp.value) payload.website = hp.value;
    } catch (e) {}

    var chatServerResponded = false;
    fetch(API_BASE + '/api/v1/chat/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      chatServerResponded = true; // server answered (any status) -> a native fallback would risk a duplicate
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function(data) {
      hideTyping();
      sessionId = data.session_id;
      hasSession = true;
      saveSession({ sessionId: sessionId, name: name, phone: phone, email: email });

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'webchat_start',
          chat_session_id: sessionId,
          store: STORE,
          user_data: {
            email_address: email || undefined,
            phone_number: phone || undefined,
            address: name ? { first_name: name } : undefined
          }
        });
      } catch (err) {}

      var formView = document.getElementById('rc-form-view');
      var chatView = document.getElementById('rc-chat-view');
      if (formView) formView.style.display = 'none';
      if (chatView) chatView.style.display = 'flex';
      setCallBtnVisible(true);

      optimisticFirstMessageBody = message;
      addMsg(message, 'out', timeNow(), 0);

      addMsg("Thanks " + name + "! We received your message. Our team will text you shortly.", 'in', null, 200);

      var chatMsgInput = document.getElementById('rc-message-chat');
      if (chatMsgInput) {
        chatMsgInput.disabled = false;
        setTimeout(function() { chatMsgInput.focus(); }, 300);
      }

      // Connect for live admin replies. Do NOT fire the silence timer on the
      // first submit — the immediate "Thanks {name}! We received your message"
      // bubble already reassures the visitor; a second "Thanks for your
      // patience" bubble 30s later reads as a duplicate. Silence-timer is
      // reserved for follow-up messages where the visitor has been waiting
      // after a real exchange.
      connectWS();
    })
    .catch(function() {
      // Transport failure (fetch threw before any response = blocked client-side
      // and never reached the server): recover the chat lead via a native
      // /contact POST. Zero-duplicate. A server error (chatServerResponded) is
      // NOT recovered here — the server may already hold the message.
      if (!chatServerResponded && chatNativeFallback(payload)) return; // navigates to /contact success
      hideTyping();
      fieldsEl.classList.remove('rc-hidden');
      if (sendBtnForm) sendBtnForm.disabled = false;
      var welcomeBubbleErr = document.querySelector('.rc-welcome-bubble');
      if (welcomeBubbleErr) welcomeBubbleErr.textContent = 'Something went wrong. Please call us at ' + PHONE_FALLBACK + ' instead.';
    });
  }

  function handleFollowUpMessage() {
    if (!validate(false)) return;

    var message = msgInput.value.trim();
    msgInput.value = '';
    msgInput.style.height = 'auto';

    if (pendingFile) {
      fileToBase64(pendingFile).then(function(b64) {
        addMsgWithAttachment(message, { data: b64, filename: pendingFile.name, content_type: pendingFile.type }, 'out', 'Sent');
        deliverFollowUp(message, { filename: pendingFile.name, content_type: pendingFile.type, data: b64, size: pendingFile.size });
        pendingFile = null;
        fileInput.value = '';
        filePreview.style.display = 'none';
        startSilenceTimer();
      });
    } else {
      addMsg(message, 'out', 'Sent', 0);
      deliverFollowUp(message, null);
      startSilenceTimer();
    }

    try {
      if (window.RolacaseTrack && typeof window.RolacaseTrack.track === 'function') {
        window.RolacaseTrack.track('chat_message_sent', { search_query: 'follow_up' });
      }
    } catch (_) {}

    msgInput.focus();
  }

  var myTypingTimeout = null;
  msgInput.addEventListener('input', function() {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 80) + 'px';

    if (hasSession && socket && socket.readyState === 1) {
      clearTimeout(myTypingTimeout);
      sendWS('typing', '');
      myTypingTimeout = setTimeout(function() {}, 3000);
    }
  });

  var greetingEl = document.getElementById('rc-greeting');
  var greetingCloseBtn = document.getElementById('rc-greeting-close');
  var greetingVisible = false;
  var greetingHideTimer = null;

  function showGreeting() {
    if (greetingVisible || isOpen) return;
    greetingVisible = true;
    greetingEl.style.display = 'block';
    greetingEl.style.animation = 'rcGreetingIn 0.4s cubic-bezier(0.34,1.56,0.64,1) forwards';
  }

  function hideGreeting() {
    if (!greetingVisible) return;
    greetingVisible = false;
    greetingEl.style.animation = 'rcGreetingOut 0.25s ease forwards';
    setTimeout(function() { greetingEl.style.display = 'none'; }, 250);
  }

  if (!sessionStorage.getItem(GREETING_KEY)) {
    setTimeout(function() {
      showGreeting();
      sessionStorage.setItem(GREETING_KEY, '1');
      greetingHideTimer = setTimeout(hideGreeting, 8000);
    }, 4000);
  }

  bubble.addEventListener('mouseenter', function() {
    if (!isOpen) {
      clearTimeout(greetingHideTimer);
      showGreeting();
    }
  });
  bubble.addEventListener('mouseleave', function() {
    greetingHideTimer = setTimeout(hideGreeting, 2000);
  });
  greetingEl.addEventListener('mouseenter', function() { clearTimeout(greetingHideTimer); });
  greetingEl.addEventListener('mouseleave', function() { greetingHideTimer = setTimeout(hideGreeting, 1500); });

  greetingCloseBtn.addEventListener('click', function(e) { e.stopPropagation(); hideGreeting(); });
  greetingEl.addEventListener('click', function() { hideGreeting(); openPanel(); });

  var callBtn = document.getElementById('rc-call-btn');
  if (callBtn) callBtn.addEventListener('click', onCallBtnClick);

  var checkName = document.getElementById('rc-check-name');
  var checkPhone = document.getElementById('rc-check-phone');
  var sendBtnForm = document.getElementById('rc-send');

  function updateValidation() {
    var nameOk = nameInput.value.trim().length > 0;
    var phoneOk = phoneInput.value.replace(/\D/g, '').length >= 8;
    var msgOk = msgInput.value.trim().length > 0;
    if (checkName) checkName.className = 'rc-check' + (nameOk ? ' rc-valid' : '');
    if (checkPhone) checkPhone.className = 'rc-check' + (phoneOk ? ' rc-valid' : '');
    if (sendBtnForm) sendBtnForm.disabled = !(nameOk && phoneOk && msgOk);
  }

  if (nameInput) nameInput.addEventListener('input', updateValidation);
  if (phoneInput) phoneInput.addEventListener('input', updateValidation);
  if (msgInput) msgInput.addEventListener('input', updateValidation);

  function setBubbleContent(iconNode, labelText) {
    while (bubble.firstChild) bubble.removeChild(bubble.firstChild);
    bubble.appendChild(iconNode);
    if (labelText) {
      var span = document.createElement('span');
      span.className = 'rc-bubble__label';
      span.textContent = labelText;
      bubble.appendChild(span);
    }
    var unread = document.getElementById('rc-unread-badge');
    if (!unread) {
      unread = document.createElement('span');
      unread.id = 'rc-unread-badge';
      unread.className = 'rc-badge';
      unread.style.display = 'none';
      unread.textContent = '0';
    }
    bubble.appendChild(unread);
    unreadBadge = unread;
  }

  function morphToClose() {
    setBubbleContent(buildCloseIcon(), '');
    bubble.classList.add('rc-close-mode');
    bubble.style.display = 'flex';
  }

  function morphToBubble() {
    setBubbleContent(buildBubbleIcon(), 'Text us');
    bubble.classList.remove('rc-close-mode');
  }

  var closeXBtn = document.getElementById('rc-close-x');

  bubble.addEventListener('click', function() {
    hideGreeting();
    if (isOpen) { closePanel(); } else { openPanel(); }
  });
  if (closeXBtn) closeXBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && isOpen) closePanel(); });

  document.addEventListener('visibilitychange', function() {
    if (!document.hidden && sessionId && (!socket || socket.readyState > 1)) {
      connectWS();
    }
  });

  var sendChatBtn = document.getElementById('rc-send-chat');
  var chatMsgInputEl = document.getElementById('rc-message-chat');

  function sendChatMessage() {
    if (!chatMsgInputEl) return;
    var message = chatMsgInputEl.value.trim();
    if (!message && !pendingFile) return;
    chatMsgInputEl.value = '';
    chatMsgInputEl.style.height = 'auto';
    if (pendingFile) {
      fileToBase64(pendingFile).then(function(b64) {
        addMsgWithAttachment(message, { data: b64, filename: pendingFile.name, content_type: pendingFile.type }, 'out', timeNow());
        deliverFollowUp(message, { filename: pendingFile.name, content_type: pendingFile.type, data: b64, size: pendingFile.size });
        pendingFile = null;
        fileInput.value = '';
        filePreview.style.display = 'none';
        startSilenceTimer();
      });
    } else {
      addMsg(message, 'out', timeNow(), 0);
      deliverFollowUp(message, null);
      startSilenceTimer();
    }
    try {
      if (window.RolacaseTrack && typeof window.RolacaseTrack.track === 'function') {
        window.RolacaseTrack.track('chat_message_sent', { search_query: 'in_session' });
      }
    } catch (_) {}
    chatMsgInputEl.focus();
  }

  if (sendChatBtn) sendChatBtn.addEventListener('click', sendChatMessage);
  if (chatMsgInputEl) {
    chatMsgInputEl.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendChatMessage(); }
    });
    chatMsgInputEl.addEventListener('input', function() {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 80) + 'px';
      if (hasSession && socket && socket.readyState === 1) {
        clearTimeout(myTypingTimeout);
        sendWS('typing', '');
        myTypingTimeout = setTimeout(function() {}, 3000);
      }
    });
  }

  var saved = loadSession();
  if (saved.sessionId) {
    sessionId = saved.sessionId;
    hasSession = true;
  }
})();
